import { PROVIDERS, WeekPlanProps } from "../../config"

interface ListDayItemProps {
	day: WeekPlanProps
}

const ListDayItem: React.FC<ListDayItemProps> = ({ day }) => {
	return (
		<section key={"daylist" + day.getDay}>
			<img src={"images/card/" + day.provider + ".png"} alt={PROVIDERS[day.provider]} className="w-full sm:cardShadow pb-[10%]" />
		</section>
	)
}

export default ListDayItem
